var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Actions, Subjects } from 'constants/accessControlList';
import { useNavigate } from 'react-router-dom';
import { Button } from 'shared/components';
import { useRbac } from 'shared/features/rbac';
import { useIsMySettings } from '../hooks';
export var SwitchSettingsAction = function () {
    var canI = useRbac().canI;
    var navigate = useNavigate();
    var isMySettings = useIsMySettings();
    var canViewAllUsers = canI(Actions.View, Subjects.UsersAllUsers);
    if (!canViewAllUsers) {
        return _jsx(_Fragment, {});
    }
    var onClick = function () { return navigate(isMySettings ? '/settings/users' : '/settings/profile'); };
    var actionCopy = isMySettings ? 'Switch to Administrative Settings' : 'Switch to My Settings';
    return (_jsx(Button, __assign({ "data-testid": "AdministrativeSettings", variant: "links", onClick: onClick }, { children: actionCopy })));
};
